/**
 * authToken.ts — bearer token storage for the embedded chat.
 *
 * The chat runs as a cross-site iframe where third-party cookies are blocked, so
 * auth uses a bearer token the app holds. We persist it in localStorage (which
 * browsers DO allow in a cross-origin iframe — partitioned per embedding site,
 * unlike cookies). If localStorage is unavailable (sandbox / "block all cookies"),
 * we fall back to an in-memory copy for the session.
 */

const KEY = 'cair_auth_token'

let memoryToken: string | undefined

export const readAuthToken = (): string | undefined => {
    try {
        return window.localStorage.getItem(KEY) || memoryToken || undefined
    } catch {
        return memoryToken
    }
}

export const writeAuthToken = (token: string): void => {
    if (!token) return
    memoryToken = token
    try {
        window.localStorage.setItem(KEY, token)
    } catch {
        /* storage unavailable — keep it in memory for this session only */
    }
}

export const clearAuthToken = (): void => {
    memoryToken = undefined
    try {
        window.localStorage.removeItem(KEY)
    } catch {
        /* ignore */
    }
}
